import { render, staticRenderFns } from "./DateSelector.vue?vue&type=template&id=45fa0fe4&scoped=true&"
import script from "./DateSelector.vue?vue&type=script&lang=ts&"
export * from "./DateSelector.vue?vue&type=script&lang=ts&"
import style0 from "./DateSelector.vue?vue&type=style&index=0&id=45fa0fe4&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fa0fe4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/opt/build/repo/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDatePicker } from 'vuetify/lib'
installComponents(component, {VDatePicker})
